import { DASH_META_ROOT } from '@revelio/auth';
import type { CompanyDiscoveryAiOutput } from '@revelio/data-access';

import { getAiSearchCsrfToken } from './ai-search-api-request';

export type ScreenerAiFilterSearchResponse = CompanyDiscoveryAiOutput;

export const screenerAiSearchRequest = async ({
  prompt,
  signal,
}: {
  prompt: string;
  signal?: AbortSignal;
}): Promise<{
  response: CompanyDiscoveryAiOutput;
  uuid: string;
}> => {
  const csrfToken = await getAiSearchCsrfToken();
  const response = await fetch(
    `${DASH_META_ROOT}/api/ai-search/company-screener`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'x-surf-token-dash-meta-ai-search': csrfToken,
      },
      body: JSON.stringify({ text: prompt }),
      credentials: 'include',
      signal,
    }
  );
  if (!response.ok) {
    throw new Error(
      `Screener AI search request failed: ${response.status} ${response.statusText}`
    );
  }
  const data: unknown = await response.json();
  return data as {
    response: CompanyDiscoveryAiOutput;
    uuid: string;
  };
};
